import React, { useEffect, useState } from 'react';
import LanguageDropdownItem from './LanguageDropdownItem';
import LanguageSelected from './LanguageSelected';

import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const LanguageDropdown = ({ position = 'default', type = 'primary' }) => {
  const dropdownId = uuidv4();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClick = e => {
      const targetClasses = e.target.classList;
      if (
        !targetClasses.contains('dropdown-item') &&
        !targetClasses.contains('dropdown-selected') &&
        !targetClasses.contains('dropdown-item-flag') &&
        !targetClasses.contains('dropdown-item-label') &&
        !targetClasses.contains('dropdown-selected-flag') &&
        !targetClasses.contains('dropdown-selected-label')
      ) {
        setIsOpen(false);
      }
    };

    document.body.addEventListener('click', handleClick);
    return () => document.body.removeEventListener('click', handleClick);
  }, []);

  const positionDropdown = () => {
    const containerDropdown = document.getElementById(
      `container-dropdown-${dropdownId}`,
    );

    if (!containerDropdown) return;

    if (position === 'top') {
      containerDropdown.style.bottom = 0;
      containerDropdown.style.left = 0;
    }

    if (position === 'default') {
      containerDropdown.style.top = 0;
      containerDropdown.style.left = 0;
    }
  };

  const handleDropdown = isOpenParam => {
    positionDropdown();
    setIsOpen(isOpenParam);
  };

  useEffect(() => {
    const onScroll = () => positionDropdown();
    document.addEventListener('scroll', onScroll);
    return () => document.removeEventListener('scroll', onScroll);
  }, [position, isOpen]);

  return (
    <div id={`dropdown-${dropdownId}`} className="dropdown">
      <LanguageSelected
        id={`language-selected-${dropdownId}`}
        isOpen={isOpen}
        handleDropdown={handleDropdown}
        type={type}
      />

      <div
        id={`container-dropdown-${dropdownId}`}
        className="container-dropdown"
      >
        {isOpen && (
          <>
            <LanguageDropdownItem
              flag={
                window.location.href.includes('.pt')
                  ? '/images/portugal-flag-icon.svg'
                  : '/images/brazil-svgrepo-com.svg'
              }
              label="PT"
              action="pt-BR"
              setIsOpen={setIsOpen}
            />

            <LanguageDropdownItem
              flag="/images/united-states-svgrepo-com.svg"
              label="EN"
              action="en-US"
              setIsOpen={setIsOpen}
            />
          </>
        )}
      </div>
    </div>
  );
};

LanguageDropdown.propTypes = {
  position: PropTypes.string,
  type: PropTypes.string,
};

export default LanguageDropdown;
